import { create } from 'zustand';

// https://zustand.docs.pmnd.rs/guides/updating-state
type State = {
    imageObj: HTMLImageElement;
    maskBase64: string;
};

type Action = {
    setImageObj: (firstName: State['imageObj']) => void;
    setMaskBase64: (lastName: State['maskBase64']) => void;
};

export const useImageInPaintEditorInfoStore = create<State & Action>((set) => ({
    imageObj: '' as any,
    maskBase64: '',
    setImageObj: (imageObj) =>
        set((state) => ({ imageObj: imageObj })),
    setMaskBase64: (maskBase64) =>
        set((state) => ({ maskBase64: maskBase64 })),
}));
